module.exports = __webpack_public_path__ + "img/forms-quizzes.034cd98.png";